import type { FlowTask } from '@Types/FlowTask.interface';
import { RequestFlowType } from '@Enums/requestFlowType.enum';
import _ from 'lodash';


export const FLOW_DEFINITIONS: Record<RequestFlowType, FlowTask[]> = {
    [RequestFlowType.Welcome]: [
        { routeName: 'welcome' },
    ],
    [RequestFlowType.WhatsNext]: [
        {
            routeName: 'whats-next'
        },
    ],
    [RequestFlowType.Startup]: [
        { routeName: 'startup' },
    ],
    [RequestFlowType.MppTransferAmount]: [
        { routeName: 'mpp-transfer-amount', displayName: 'Review money protection plan' },
    ],
    [RequestFlowType.MppPurchaseDecision]: [
        { routeName: 'mpp-purchase-decision' },
        { routeName: 'mpp-payment-details' },
    ],
    [RequestFlowType.HeroPackage]: [
        { routeName: 'hero-package', displayName: 'Review money protection plan' },
    ],
    [RequestFlowType.PaymentRequestOverview]: [
        { routeName: 'payment-request-overview', displayName: 'Review payment request' },
    ],
    [RequestFlowType.PaymentMethodSelect]: [
        { routeName: 'payment-method-select', displayName: 'Choose payment method' },
    ],
    [RequestFlowType.WireInstructionsReady]: [
        { routeName: 'wire-instructions-ready', displayName: 'Download wire instructions' },
    ],
    [RequestFlowType.WireInstructions]: [
        { routeName: 'wire-instructions', displayName: 'Download wire instructions' },
    ],
    [RequestFlowType.ClientHubConfirmComplete]: [
        { routeName: 'confirm-complete', displayName: 'Confirm bank details' },
    ],
    [RequestFlowType.ClientHubConfirmReview]: [
        { routeName: 'confirm-review', displayName: 'Confirm bank details' },
    ],
    [RequestFlowType.ClientHubRequestBlocked]: [
        { routeName: 'request-blocked' },
    ],
    [RequestFlowType.ClientHubCollectAccountDetails]: [
        { routeName: 'collect-account-details', displayName: 'Submit bank details' },
    ],
    [RequestFlowType.ClientHubCollectReview]: [
        { routeName: 'collect-review' },
    ],
    [RequestFlowType.ClientHubCollectComplete]: [
        { routeName: 'collect-complete', displayName: 'Submit bank details' },
    ],
    [RequestFlowType.ClientHubVerificationDocType]: [
        { routeName: 'match-idv-select-doc-type', displayName: 'Choose ID type' },
    ],
    [RequestFlowType.ClientHubVerificationProcessing]: [
        { routeName: 'match-idv-processing-complete', displayName: 'Processing verification' },
    ],
};


export const isFeatureFlowType = (val: string): val is RequestFlowType => {
    return _.includes(_.values(RequestFlowType), val);
};
